module.exports = __webpack_public_path__ + "img/boaz-back.66828a7b.webp";